import axios from 'axios';

export default {
  index: (config = {}) => axios.get('areas', config),
};
